import React from 'react';
import { Link } from 'react-router-dom';
import WhatsAppButton from '../common/WhatsAppButton';
import './Hero.css'; // Assuming you have a CSS file for styling

const Hero = () => {
    return (
        <div className="hero">
            <div className="hero-content">
                <h1>Find Your Dream Home</h1>
                <p>Your perfect property is just a click away.</p>
                <Link to="/properties" className="btn">View Listings</Link>
                <WhatsAppButton />
            </div>
        </div>
    );
};

export default Hero;